/**
 * @generated SignedSource<<254d867d38ac2047e1b355de64e44419>>
 * @relayHash 74a6ed725a3c21301a8a9e20260043d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainHorizontalNavCsmSupportWebsiteQuery } from './mainHorizontalNavCsmSupportWebsiteQuery.graphql';

const node: PreloadableConcreteRequest<mainHorizontalNavCsmSupportWebsiteQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d",
    "metadata": {},
    "name": "mainHorizontalNavCsmSupportWebsiteQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
